// extracted by mini-css-extract-plugin
export default {"row":"selected-coupon_row__HI+vz","content":"selected-coupon_content__ieZ3M","col":"selected-coupon_col__bDXi5","removeIcon":"selected-coupon_removeIcon__jtGgq"};